module.exports = __webpack_public_path__ + "static/img/bonus_1.665b851.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zeus/bonus_1.png
// module id = QDwM
// module chunks = 0